import { render, staticRenderFns } from "./bidding_list.vue?vue&type=template&id=ee2d32e4&scoped=true&"
import script from "./bidding_list.vue?vue&type=script&lang=js&"
export * from "./bidding_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2d32e4",
  null
  
)

export default component.exports